module.exports = __webpack_public_path__ + "static/meeting1-9dad98b8c9a070813a79b82de55ed935.png";